import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"แปลเอกสาร + Apostille แพ็กเกจครบวงจร — Translate & Apostille Bundle","metaTitle":"แปลเอกสาร + Apostille ครบชุด รับรอง MFA/สถานทูต | NYC","metaDesc":"แปลไทย↔อังกฤษ + รับรอง MFA + Apostille/Legalization สำหรับ 130 ประเทศ Hague Convention 1961 เสร็จภายใน 10 วันทำกา — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย"},"en":{"h1":"Translation + Apostille Bundle — End-to-End for 126 Hague Countries","metaTitle":"Translate + Apostille Package | MFA + Hague Convention | NYC","metaDesc":"Thai↔English translation + MFA authentication + Apostille/Legalization for 126 Hague countries. delive — Free consultation — message us for a same-day answer."}} as const;

export const Route = createFileRoute("/translate/apostille-package")({
  head: () => {
    const url = `${SEO_SITE}/translate/apostille-package`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/translate/apostille-package", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/translate/apostille-package", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/translate/apostille-package", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/translate/apostille-package", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/translate/apostille-package", "/en/translate/apostille-package")],
    };
  },
  component: () => <SubServicePage slug="translate/apostille-package" locale="th" />,
});
